/**
 * 格式化工具函数
 */

import { Task } from '../types';
import { colors } from './colors';

export function formatTaskList(tasks: Task[]): string {
  if (tasks.length === 0) {
    return colors.dim('No tasks found');
  }

  return tasks.map((task, index) => {
    const priorityColor = task.priority === 'high' ? colors.red :
                         task.priority === 'low' ? colors.green : colors.yellow;
    
    const statusIcon = task.status === 'completed' ? '✓' :
                      task.status === 'in_progress' ? '⚡' : '○';
    
    return `${colors.dim(`${index + 1}.`)} ${statusIcon} ${task.content} ${priorityColor(`[${task.priority}]`)}`;
  }).join('\n');
}

export function formatDuration(ms: number): string {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes % 60}m`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s`;
  } else {
    return `${seconds}s`;
  }
}

export function formatProgress(current: number, total: number): string {
  const percentage = Math.round((current / total) * 100);
  const filled = Math.floor(percentage / 5);
  const empty = 20 - filled;
  
  const bar = '█'.repeat(filled) + '░'.repeat(empty);
  return `${bar} ${percentage}%`;
}